module.exports = __webpack_public_path__ + "static/media/EVERYBODY-ELSE-IS-TAKEN.1cb2ec6d.png";